import styled from 'styled-components'

import { PointList } from 'components/Layout'

export const PolicyList = styled(PointList)`
	padding: 4px 0;

	&:last-child {
		margin-bottom: 0;
	}
`
